var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.kind == "text"
        ? _c("v-text-field", {
            attrs: {
              value: _vm.value,
              placeholder: "Search " + _vm.label.toLowerCase(),
              "prepend-inner-icon": _vm.$MDI.Magnify,
              dense: "",
              outlined: "",
              "hide-details": "",
              clearable: "",
            },
            on: { input: _vm.onText },
          })
        : _vm.kind == "choice"
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "field-hint text-caption text--secondary mb-2" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      staticStyle: { "margin-top": "2px" },
                      attrs: { small: "" },
                    },
                    [_vm._v(_vm._s(_vm.$MDI.FilterOutline))]
                  ),
                  _vm._v(
                    "\n            Show only hits on one \n            " +
                      _vm._s(_vm.label.toLowerCase()) +
                      "\n        "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn-toggle",
                {
                  attrs: { value: _vm.value, color: _vm.color, dense: "" },
                  on: { change: (v) => _vm.$emit("filter", v ?? null) },
                },
                _vm._l(_vm.choices, function (choice) {
                  return _c(
                    "v-btn",
                    {
                      key: choice.value,
                      staticStyle: { "text-transform": "none" },
                      attrs: { value: choice.value, small: "" },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(choice.text) +
                          "\n            "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm.kind == "tax"
        ? _c("TaxonomyAutocomplete", {
            attrs: { value: _vm.taxSelection, localItems: _vm.taxOptions },
            on: { input: _vm.onTaxon },
          })
        : _vm.kind == "range" && _vm.bounds
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  staticClass:
                    "field-hint range-hint text-caption text--secondary",
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      staticStyle: { "margin-top": "2px" },
                      attrs: { small: "" },
                    },
                    [_vm._v(_vm._s(_vm.$MDI.FilterOutline))]
                  ),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.singleValue
                          ? "All hits have the same value"
                          : "Drag the handles to filter by range"
                      ) +
                      "\n        "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-range-slider", {
                staticClass: "mx-1",
                attrs: {
                  value: _vm.singleValue ? [0, 1] : _vm.sliderValue,
                  min: _vm.singleValue ? 0 : _vm.scale.min,
                  max: _vm.singleValue ? 1 : _vm.scale.max,
                  step: _vm.integer && !_vm.singleValue ? 1 : 0,
                  disabled: _vm.singleValue,
                  color: _vm.color,
                  "track-color": _vm.color,
                  "thumb-label": "",
                  "thumb-size": 44,
                  "hide-details": "",
                },
                on: { change: _vm.onSlider, end: _vm.releaseThumb },
                scopedSlots: _vm._u([
                  {
                    key: "thumb-label",
                    fn: function ({ value: position }) {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.formatPosition(position)) +
                            "\n            "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex mt-2", staticStyle: { gap: "8px" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      value: _vm.displayRange[0],
                      label: "Min",
                      dense: "",
                      outlined: "",
                      "hide-details": "",
                      disabled: _vm.singleValue,
                    },
                    on: { change: (v) => _vm.onInput(0, v) },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      value: _vm.displayRange[1],
                      label: "Max",
                      dense: "",
                      outlined: "",
                      "hide-details": "",
                      disabled: _vm.singleValue,
                    },
                    on: { change: (v) => _vm.onInput(1, v) },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.value != null
        ? _c(
            "div",
            { staticClass: "d-flex justify-end mt-2" },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "", small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("filter", null)
                    },
                  },
                },
                [_vm._v("Clear filter")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }